import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { jsonToQueryString } from '@/utils'

import { PlayerCardActionTypes } from '../constants'
import { PLAYER_CARD } from './api.routes'
import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const getPlayerBalanceThunk = createAsyncThunk(
  PlayerCardActionTypes.GET_PLAYER_BALANCE,
  async (payload: PlayerCardModels.GetPlayerBalancePayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'GET',
        // endpoint: `${PLAYER_CARD.GET_PLAYER_BALANCE}/f1c808ad-dda5-4aa5-8553-63f99562ad05/${payload.playerId}`,
        endpoint: `${PLAYER_CARD.GET_PLAYER_BALANCE}/${auth.brand.siteId.toString()}/${
          payload.playerId
        }`,
        queries: jsonToQueryString({
          ...payload,
          brandId: auth.brand.siteId.toString(),
          //brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
          limit: 10,
          page: 1,
        }),
        isIncentiveAPI: true,
      }

      const response: PlayerCardModels.GetPlayerBalanceResponse =
        await apiService.getData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)

export const getPlayerBalanceExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(getPlayerBalanceThunk.pending, (state) => {
    state.isLoadingSearch = true
  })
  builder.addCase(getPlayerBalanceThunk.fulfilled, (state, { payload }) => {
    state.isLoadingSearch = false
    state.wallet = payload.wallet
  })
}
